import { es } from 'date-fns/locale';
const dateEsAR = {
  name: 'es-AR',
  locale: es
};
export default dateEsAR;